import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import checkUpBanner from '../../../../../../assets/images/gradient-round/check-up-banner.svg';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  cvBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '0.75rem',
    margin: '1rem 0',
    borderRadius: '0.5rem',
    backgroundColor: palette.secondary.light,
  },
  cvBannerIcon: {
    flexShrink: 0,
    width: '3rem',
    height: '3rem',
    background: `no-repeat transparent url(${checkUpBanner}) center`,
    backgroundSize: 'contain',
  },
  cvBannerText: {
    margin: 0,
    color: palette.text.primary,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
}));
